// extracted by mini-css-extract-plugin
module.exports = {"title":"VisibilityCard_title__3Zy39","main":"VisibilityCard_main__1lJQT","value":"VisibilityCard_value__2pnSB"};